export class ContactForm{
    requestorFirstName:string;
    requestorLastName:string;
    requestorPhone:string;
    requestorEmail:string;
    requestorMessage:string;
}